"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var react_1 = __importStar(require("react"));
var Case_1 = require("./Case");
var Default_1 = require("./Default");
var helpers_1 = require("./helpers");
function Switch(_a) {
    var condition = _a.condition, children = _a.children, _b = _a.loose, loose = _b === void 0 ? false : _b, _c = _a.booleanify, booleanify = _c === void 0 ? false : _c;
    var sanitizedCondition = condition !== null && condition !== void 0 ? condition : true;
    var childrenArray = react_1.Children.toArray(children);
    helpers_1.assert(childrenArray.every(function (child) {
        if (typeof child != "object")
            return false;
        return child.type === Case_1.Case || child.type === Default_1.Default;
    }), "Only components of type " + "Case" + " or " + "Default" + " can be specified directly inside the switch.");
    var cases = childrenArray.filter(function (_a) {
        var childType = _a.type;
        return childType === Case_1.Case;
    });
    helpers_1.assert(cases.length > 0, "No " + "Case" + " components specified for " + "Switch" + " component, are you sure that " + "Switch" + " has to be specified?");
    var defaults = childrenArray.filter(function (_a) {
        var childType = _a.type;
        return childType === Default_1.Default;
    });
    helpers_1.assert(defaults.length <= 1, "More than one (" + defaults.length + ") " + "Default" + " components specified for " + "Switch" + " component, are you sure that you need that many?");
    var truthyCase = cases.find(function (_a) {
        var childWhen = _a.props.when;
        if (booleanify)
            return !!childWhen === !!sanitizedCondition;
        if (loose)
            return childWhen == sanitizedCondition;
        return childWhen === sanitizedCondition;
    });
    return (react_1.default.createElement(react_1.Fragment, null, truthyCase
        ? react_1.cloneElement(truthyCase, {
            when: true,
        })
        : defaults[0] || null));
}
exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map